import React from "react";
import { Card, Icon } from "semantic-ui-react";

function CardNotEnoughCredits() {
  return (
    <Card>
      <Card.Content>
        <Card.Header>Not enough credits ?</Card.Header>
        <Card.Description>
          No worries, you can click at the button below and purchase credits at a new tab.
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <a href="/panel/credits/purchaseCredits" target="_blank" className="ui button primary">
          <Icon name="external" />
          Purchase credits
        </a>
      </Card.Content>
    </Card>
  );
}

export default CardNotEnoughCredits;
